// extracted by mini-css-extract-plugin
export default {"managerContent":"managerContent---mkwOQ","settingChoose":"settingChoose---Nxsa9","panePlaceholder":"panePlaceholder---ahlt5"};